import { ChakraProvider } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import { PageViews, ScrollToTop } from "@/components";
import { theme } from "@/theme";

export const Root = () => (
  <ChakraProvider theme={theme}>
    <ScrollToTop />
    <PageViews />
    <Outlet />
  </ChakraProvider>
);
